// ────────────────────────────────────────────────────────────────
// Firebase web app configuration for project: ApexCarCare
// (project id: apexcarcare-e8ba8, app: "ApexCarCare Website")
// These values are public identifiers, not secrets — access control
// lives in firestore.rules / storage.rules.
// ────────────────────────────────────────────────────────────────

export const firebaseConfig = {
  apiKey: 'AIzaSyAOU6IhRvMbKO74yiQiLymCH5KSpdWi3vU',
  authDomain: 'apexcarcare-e8ba8.firebaseapp.com',
  projectId: 'apexcarcare-e8ba8',
  storageBucket: 'apexcarcare-e8ba8.firebasestorage.app',
  messagingSenderId: '154841392812',
  appId: '1:154841392812:web:74b66023d94c5140dda109',
};

// Verified accounts with these emails are automatically admins.
// (Also update the matching list in firestore.rules and storage.rules
// if you change it.) Additional admins can be added in the admins
// collection without touching code.
export const ADMIN_EMAILS = ['matt@thestarlordz.com'];

export const isFirebaseConfigured = () =>
  !firebaseConfig.apiKey.startsWith('PASTE_') && !firebaseConfig.appId.startsWith('PASTE_');
